export default "__VITE_ASSET__By30mu99__"